/** @flow */
import React from "react";
import classNames from "classnames";
import "./button.style.scss";

export type ButtonColor =
  | "selected"
  | "positive"
  | "negative"
  | "negative-outline"
  | "secondary"
  | "pumpkin-orange"
  | "risk-high"
  | "risk-medium"
  | "berry"
  | "pumpkin-orange-outline"
  | "black"
  | null;

export type ButtonProps = {
  id?: "string",
  name?: "string",
  size?: "extra-small" | "small" | "big",
  type?: "button" | "submit" | "reset" | "file",
  color?: ButtonColor,
  materialIcon?: string | boolean,
  iconSize?: number,
  fillSpace?: boolean,
  className?: string,
  onClick?: Function,
  children?: string | React$Node,
  label?: string,
  disabled?: boolean,
  value?: string,
};

const Button = ({ size = "default", color, fillSpace, className, ...props }: ButtonProps) => {
  const materialIcon = props.materialIcon;

  delete props.materialIcon; // Since {...props} is spreading all the props, we need to remove
  delete props.iconSize;
  return (
    <button
      {...props}
      name={props.name}
      id={props.id || props.name}
      style={{ padding: props.iconSize && `0 ${props.iconSize / 5}rem` }}
      className={classNames(
        "button justify-content-center align-items-center",
        {
          [size]: size,
          [color || "default"]: color,
          "with-icon": materialIcon,
          "fill-space": fillSpace,
        },
        className,
      )}
    >
      {materialIcon && (
        <span
          style={{
            fontSize: `${String(props.iconSize)}rem`,
          }}
          className={`material-icons ${!props.children && !props.label ? "m-0" : ""}`}
        >
          {materialIcon}
        </span>
      )}
      {props.children || props.label}
    </button>
  );
};
export default Button;
